<mat-paginator
    [hidden]="!params || params?.length < limiterLength.PageItemsSize"
    [length]="params?.length"
    [pageSize]="params?.pageSize"
    [pageSizeOptions]="params?.pageSizeOptions"
    [showFirstLastButtons]="false"
    [hidePageSize]="false"
    [attr.aria-label]="'aria-label.paginator' | translate"
    [pageIndex]="params?.pageIndex"
    (page)="pagination.emit($event)" />
